import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("Token3gen");
  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
